import { helper } from '@ember/component/helper';

// Costanti per conversione tempo
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;
const SECONDS_PER_DAY = 86400;
const SECONDS_PER_YEAR = 31536000;

/**
 * Formatta minuti in stringa leggibile (anni, giorni, ore, minuti)
 */
function formatMinute2string([minutes]) {
  if (minutes == null || typeof minutes === 'string' && minutes.trim() === '') return '';
  const parsed = parseFloat(minutes);
  if (isNaN(parsed)) return '';
  if (parsed === 0) return '0 m';

  // Decomponi il valore assoluto e anteponi un solo segno al risultato,
  // altrimenti -1 min → "-1 y -1 d -1 h -1 m".
  const sign = parsed < 0 ? '-' : '';
  const seconds = Math.abs(parsed) * SECONDS_PER_MINUTE;
  if (isNaN(seconds)) return '';
  const parts = [];
  let remaining = seconds;
  const years = Math.floor(remaining / SECONDS_PER_YEAR);
  if (years) {
    parts.push(`${years} y`);
    remaining %= SECONDS_PER_YEAR;
  }
  const days = Math.floor(remaining / SECONDS_PER_DAY);
  if (days) {
    parts.push(`${days} d`);
    remaining %= SECONDS_PER_DAY;
  }
  const hours = Math.floor(remaining / SECONDS_PER_HOUR);
  if (hours) {
    parts.push(`${hours} h`);
    remaining %= SECONDS_PER_HOUR;
  }
  const mins = Math.floor(remaining / SECONDS_PER_MINUTE);
  if (mins) {
    parts.push(`${mins} m`);
  }
  return `${sign}${parts.join(' ')}`;
}
var formatMinute2stringDay = helper(formatMinute2string);

export { formatMinute2stringDay as default, formatMinute2string };
//# sourceMappingURL=format-minute2string-day.js.map
